import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { locationColour } from '../utils';
import { Link } from 'react-router-dom';

class WallLocationPicker extends Component {

  constructor( props ) {
    super( props );
    this.list = React.createRef();
    this.scrollContainer = React.createRef();
    this.state = {
      margin: 0,
    }
  }

  componentDidUpdate( prevProps ) {
    if ( this.props.wallHeight !== prevProps.wallHeight || this.props.locationList !== prevProps.locationList) {
      if( this.list.current.children[0] ) {
        this.setState( {
          margin: this.scrollContainer.current.clientHeight - this.list.current.children[0].clientHeight,
        } );
      }
    }
    if ( this.props.currentLocationIndexChangedByNav && ( this.props.currentLocationIndex !== prevProps.currentLocationIndex ) ) {
      this.scrollContainer.current.scrollTop = this.list.current.children[0].clientHeight * this.props.currentLocationIndex;
      this.props.setIndex( this.props.currentLocationIndex, false );
    }
  }

  newScrollHandler = debounce(() => {
    if( !this.props.currentLocationIndexChangedByNav ) {
      let index = Math.floor( this.scrollContainer.current.scrollTop / this.list.current.clientHeight * this.props.locationList.length );
      this.props.setIndex( index, false );
    }
  }, 250);

  render() {
    return (
      <div className="WallLocationPicker">
      <div
        className="WallLocationUlHolder"
        onScroll={this.newScrollHandler}
        ref={this.scrollContainer}>
        <ul
          ref={this.list}
          style={{ marginBottom: this.state.margin }}>
          {this.props.locationList.map( ( location, i ) => {
            return (
              <li key={i} className={classNames( { 'current': this.props.currentLocationIndex === i } )}>
                <span className="sample" style={{ backgroundColor: locationColour( location.node.nid, this.props.locations ) }}/>
                <Link to={'/location?location=' + location.node.nid}>{location.node.title}</Link>
              </li>
            )
          } )}
        </ul>
      </div>
      <div className="WallLocationUlCover"/>
      </div>
    )
  }
}

function mapStateToProps( state ) {
  return {
    locations: state.data.locations,
  };
}

export default connect( mapStateToProps )( WallLocationPicker );